import { Component, inject } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';
import { NgChartsModule } from 'ng2-charts';

import { SvgIcon } from ':shared/enums';

@Component({
    selector: 'app-imit-exceeded-popin',
    templateUrl: './limit-exceeded-popin.component.html',
    styleUrls: ['./limit-exceeded-popin.component.scss'],
    imports: [NgChartsModule, MatIconModule, TranslateModule],
})
export class LimitExceededPopinComponent {
    private readonly _dialogRef = inject(MatDialogRef);

    readonly SvgIcon = SvgIcon;

    cancel(done: boolean = false): void {
        this._dialogRef.close(done);
    }
}
